import { v4 as uuidv4 } from 'uuid'

import apiZervant from '../../../utils/apiZervant'

export const getUploadAttachmentSessionUrl = () => {
  const sessionId = uuidv4()
  const url = apiZervant.urls.invoiceDelivery(`/attachment/${sessionId}`)

  return { sessionId, url }
}
